/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Knp_ManagerInputs */



/**
* | output |
* | --- |
* | "KNP Manager" |
*
* @param {Knp_ManagerInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const knp_manager = /** @type {((inputs?: Knp_ManagerInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Knp_ManagerInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Gestionnaire KNP")
	if (locale === "de") return /** @type {LocalizedString} */ ("KNP-Manager")
	if (locale === "it") return /** @type {LocalizedString} */ ("Responsabile KNP")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Менеджер КНП")
	if (locale === "es") return /** @type {LocalizedString} */ ("Gerente de KNP")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("KNP经理")
	if (locale === "ja") return /** @type {LocalizedString} */ ("KNPマネージャー")
	if (locale === "hi") return /** @type {LocalizedString} */ ("केएनपी प्रबंधक")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Gerente do KNP")
	return /** @type {LocalizedString} */ ("KNP Manager")
});